import { render, staticRenderFns } from "./CookieBannerPreview.vue?vue&type=template&id=36d92ad6&scoped=true"
import script from "./CookieBannerPreview.vue?vue&type=script&lang=ts"
export * from "./CookieBannerPreview.vue?vue&type=script&lang=ts"
import style0 from "./CookieBannerPreview.vue?vue&type=style&index=0&id=36d92ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d92ad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VFadeTransition,VOverlay})
